<template>
    <div class="trend">
      <div class="banner">
        <img src="~imgs/home/bg.jpg" alt="">
      </div>
      <!-- <div class="main">
        <div class="title">
          金政动态
        </div>
      </div> -->
      <div class="category">
        <a href="javascript:"
           :class="{active:active===item.id}"
           v-for="(item, index) in typeList"
           :key="index"
           @click="onChange(item.id,index)">
         {{item.name}}
        </a>
      </div>
      <div class="container">
        <div class="list-wrapper" v-if="showList">
          <div class="list">
            <router-link :to="`/trend-detail/${item.id}`" v-for="item in articleList" :key="item.id">
              <div class="title">
                {{item.title}}
              </div>
              <div class="time">
                {{item.releaseTime}}
              </div>
            </router-link>
          </div>
          <el-pagination v-if="total>10"
                         layout="prev, pager, next"
                         :total="total"
                         :page-size="10"
                         :current-page.sync="currentPage"
                         @current-change="handleCurrentChange">
          </el-pagination>
        </div>
        <div class="train" v-if="!showList">
          <div class="train-content container">
            <div class="item">
              <div class="title">
                <p>资产管理系统培训</p>
              </div>
              <div class="content">
                <div class="left">
                  培训内容培训内容培训内容培训内容培训内容，培训内容培训内容培训内容培训内容。
                  培训内容培训内容培训内容。培训内容培训内容培训内容培训内容，培训内容培训内容培训内容培训内容。
                  培训内容培训内容培训内容培训内容，培训内容培训内容培训内容培训内容。
                </div>
                <div class="right">
                  <img src="~imgs/home/qrcode.jpg" alt="" style="width: 600px;">
                </div>
              </div>
            </div>
            <div class="item">
              <div class="title">
                <p>资产管理系统培训</p>
              </div>
              <div class="content">
                <div class="left">
                  培训内容培训内容培训内容培训内容培训内容，培训内容培训内容培训内容培训内容。
                  培训内容培训内容培训内容。培训内容培训内容培训内容培训内容，培训内容培训内容培训内容培训内容。
                  培训内容培训内容培训内容培训内容，培训内容培训内容培训内容培训内容。
                </div>
                <div class="right">
                  <img src="~imgs/home/qrcode.jpg" alt="" style="width: 600px;">
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
export default {
  name: "index",
  data() {
    return {
      typeList: [],
      articleList: [],
      active: 0,
      currentPage: 1,
      total: 0,
      showList: true
    };
  },
  watch: {
    $route() {
      this.update();
    }
  },
  created() {
    this.update();
  },
  methods: {
    update() {
      this.$nextTick(() => {
        document.documentElement.scrollTop = +this.$route.params.top;
        document.body.scrollTop = +this.$route.params.top;
      });
    },
    getArticle(id, page = 1, i = 0) {
      this.currentPage = page;
      if (i === 2) {
        this.active = id;
        this.showList = false;
        return;
      }
      this.showList = true;
    },
    handleCurrentChange(val) {
      this.getArticle(this.active, val);
    },
    onChange(id, index) {
      if (this.active === id) {
        return;
      }
      this.$router.push({
        name: "trend",
        params: {
          id: index + 1,
          top:
            document.body.scrollTop === 0
              ? document.documentElement.scrollTop
              : document.body.scrollTop
        }
      });
      this.getArticle(item.id, 1, index);
    }
  }
};
</script>
